<template>
  <div class="table-tooltip">
    <el-popover
      placement="top"
      width="200"
      trigger="hover"
      :content="content"
    >
      <el-button
        slot="reference"
        icon="el-icon-warning"
        circle
      ></el-button>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'table-tooltip',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
}

</script>

<style scope>
.table-tooltip {
  padding-right: 0 !important;
}
.table-tooltip .el-button {
  border: none !important;
}
.table-tooltip .el-button.is-circle {
  padding: 0 !important;
}
.table-tooltip .el-button:focus,
.table-tooltip .el-button:hover {
  background-color: transparent;
}
.table-tooltip .el-button:focus {
  color: initial;
}
</style>